export const getValueFromInstance = (key, encodedInstance) => {
    const decodeFunc = typeof atob === 'undefined' ? nodeDecoder : atob;
    const encodedData = encodedInstance.split('.').pop();
    if (!encodedData) {
        return undefined;
    }
    const decodedData = decodeFunc(encodedData);
    const instanceObject = JSON.parse(decodedData);
    return instanceObject[key];
};
function nodeDecoder(encodedData) {
    // added "global." to prevent Buffer polyfill in webpack
    return global.Buffer.from(encodedData, 'base64').toString();
}
//# sourceMappingURL=wix-instance-value.js.map